<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-container>
            <v-row>
              <v-col cols="11">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="headline">{{ activity.title }}</v-list-item-title>
                    <v-list-item-subtitle>by {{ activity.author_name }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="1">
                <v-card-actions>
                  <v-btn icon>
                    <v-badge
                      color="grey"
                      :content="activity.hearts_count"
                      left
                    >
                      <v-icon v-if="activity.current_user_heart">mdi-heart</v-icon>
                      <v-icon v-else>mdi-heart-outline</v-icon>
                    </v-badge>
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-container>

          <v-img
            src="@/assets/img/kitchen-cuttingboard.webp"
            height="300"
          ></v-img>

          <v-container>
            <v-row>
              <v-col cols="4">
                <v-card-subtitle>
                  <v-text-field
                    label="Starts at:"
                    :value="activity.start_time | formatDate"
                    type="datetime"
                    prepend-icon="mdi-alarm"
                    suffix="GMT+4"
                    readonly
                    rounded
                    dense
                    outlined
                  ></v-text-field>
                </v-card-subtitle>
              </v-col>
              <v-col cols="8">
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    rounded
                    color="lime accent-4"
                    :to="/activity/ + activity.id"
                    :activityId="activity.id"
                  >
                    Request Comments Access
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-container>

          <v-card-text>{{ activity.description }}</v-card-text>

          <v-card-text>
            <v-chip-group
              multiple
              active-class="primary--text"
            >
              <v-chip v-for="tag in activity.tags" :key="tag">
                {{ tag }}
              </v-chip>
            </v-chip-group>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ActivityCard',
  props: ['activityId'],
  methods: {
    ...mapActions(['fetchActivity'])
  },
  computed: mapGetters(['activity']),
  created() {
    this.fetchActivity(this.$route.params.activityId)
  }
}
</script>